module.exports = __webpack_public_path__ + "img/whats-an-mmog.c3b4b9a5.jpg";